import React from 'react';
import { useSelector } from 'react-redux';
import { hasPermission, hasAnyPermission, hasAllPermissions } from '../utils/permissionUtils';

// Component to guard based on a single permission
export const PermissionGuard = ({ permission, children, fallback = null }) => {
  const { user } = useSelector(state => state.auth);
  
  if (!hasPermission(user, permission)) {
    return fallback;
  }
  
  return children;
};

// Component to guard based on any of multiple permissions
export const AnyPermissionGuard = ({ permissions, children, fallback = null }) => {
  const { user } = useSelector(state => state.auth);
  
  if (!hasAnyPermission(user, permissions)) {
    return fallback;
  }
  
  return children;
};

// Component to guard based on all permissions
export const AllPermissionsGuard = ({ permissions, children, fallback = null }) => {
  const { user } = useSelector(state => state.auth);
  
  if (!hasAllPermissions(user, permissions)) {
    return fallback;
  }
  
  return children;
}; 